// extracted by mini-css-extract-plugin
module.exports = {"keyword":"keyword-action_keyword__2KIH8"};